import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ClientDetailsFormFields = ({
  formData,
  errors,
  onChange,
  onSubmit,
  isSubmitting,
  paymentQuote,
  isPaymentRequired,
  isQuoteLoading,
}) => {
  const [showSpecialRequests, setShowSpecialRequests] = useState(false);

  const formatPhoneNumber = (value) => {
    const cleaned = value?.replace(/\D/g, '');
    const match = cleaned?.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
    if (match) {
      return !match?.[2] ? match?.[1] : `(${match?.[1]}) ${match?.[2]}${match?.[3] ? `-${match?.[3]}` : ''}`;
    }
    return value;
  };

  const handlePhoneChange = (e) => {
    const formatted = formatPhoneNumber(e?.target?.value);
    onChange({ target: { name: 'phone', value: formatted } });
  };

  return (
    <form onSubmit={onSubmit} className="space-y-4 md:space-y-6">
      <div className="space-y-4 md:space-y-5">
        <Input
          label="Full Name"
          type="text"
          name="name"
          placeholder="Enter your full name"
          value={formData?.name}
          onChange={onChange}
          error={errors?.name}
          required
          description="Please provide your first and last name"
        />

        <Input
          label="Phone Number"
          type="tel"
          name="phone"
          placeholder="(555) 123-4567"
          value={formData?.phone}
          onChange={handlePhoneChange}
          error={errors?.phone}
          required
          description="We'll use this to confirm your appointment"
        />

        <Input
          label="Email Address"
          type="email"
          name="email"
          placeholder="your.email@example.com"
          value={formData?.email}
          onChange={onChange}
          error={errors?.email}
          required
          description="Booking confirmation will be sent to this email"
        />

        <div className="space-y-3">
          <button
            type="button"
            onClick={() => setShowSpecialRequests(!showSpecialRequests)}
            className="flex items-center gap-2 text-primary hover:text-primary/80 transition-colors duration-250 font-caption font-medium text-sm md:text-base"
          >
            <Icon 
              name={showSpecialRequests ? 'ChevronDown' : 'ChevronRight'} 
              size={20} 
            />
            <span>Add special requests or preferences (optional)</span>
          </button>

          {showSpecialRequests && (
            <div className="animate-scale-in">
              <label className="block text-sm md:text-base font-caption font-medium text-foreground mb-2">
                Special Requests
              </label>
              <textarea
                name="specialRequests"
                value={formData?.specialRequests}
                onChange={onChange}
                placeholder="Let us know if you have any specific preferences, allergies, or special requests..."
                rows={4}
                className="w-full px-4 py-3 bg-card border border-input rounded-lg text-sm md:text-base text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-250 resize-none"
              />
              <p className="mt-2 text-xs md:text-sm text-muted-foreground font-caption">
                This helps us provide you with the best possible service
              </p>
            </div>
          )}
        </div>
      </div>
      <div className="pt-4 md:pt-6 space-y-3 md:space-y-4">
        <Button
          type="submit"
          variant="default"
          size="lg"
          fullWidth
          loading={isSubmitting}
          disabled={isQuoteLoading}
          iconName={isPaymentRequired ? 'CreditCard' : 'Check'}
          iconPosition="right"
          className="shadow-lg hover:shadow-xl"
        >
          {isSubmitting
            ? 'Processing...'
            : isPaymentRequired && paymentQuote
              ? `Confirm & Pay GH¢${Number(paymentQuote.total).toFixed(2)}`
              : 'Confirm Booking'}
        </Button>

        <div className="flex items-start gap-2 p-3 md:p-4 bg-muted/50 rounded-lg">
          <Icon name="Shield" size={18} className="text-success mt-0.5 flex-shrink-0" />
          <p className="text-xs md:text-sm text-muted-foreground font-caption leading-relaxed">
            Your information is secure and will only be used for appointment management. We respect your privacy.
          </p>
        </div>
      </div>
    </form>
  );
};

export default ClientDetailsFormFields;
